import { useRecoilValue } from "recoil";
import { isLoginSelector } from "../Hooks/TokenAtom";
import { Outlet, Navigate } from "react-router-dom";

const ProtectedRoute = () => {
  const isLogin = useRecoilValue(isLoginSelector);

  return isLogin ? <Outlet /> : <Navigate to={"/Login"} replace={true} />;
};

export default ProtectedRoute;
